import { Delete } from "@mui/icons-material";
import { Button, ListItemIcon, MenuItem } from "@mui/material";
import { labelButtonStyle } from "../../../../components/shared/PopupMenu";
import { PlanTableFormat } from "../../../../types/planning/plan.type";
import { useActionsMenuContext } from "../../shared/ActionsMenuContext";

type DeletePlanMenuItemProps = {
  routesOrTraps: PlanTableFormat[];
  /** Omit if don't want to call it after the action */
  handleClose?: () => void;
  clearSelection?: () => void;
};

export const DeletePlanMenuItem = ({
  routesOrTraps,
  handleClose,
  clearSelection = () => {},
}: DeletePlanMenuItemProps) => {
  const { openDialog } = useActionsMenuContext();
  return (
    <MenuItem
      onClick={() => {
        handleClose?.();
        openDialog({
          name: "delete-plan",
          planSummaries: routesOrTraps,
          clearSelection,
        });
      }}
    >
      <ListItemIcon>
        <Delete />
      </ListItemIcon>
      <Button sx={labelButtonStyle} disableRipple>
        Delete
      </Button>
    </MenuItem>
  );
};
